import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { Field, Form } from "formik";
import { OutSideClick } from "../Utility/Method/OutSideClick";
import Col from "./Column";
export const StyledForm = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: auto;
`;

export const StyledInput = styled(Field)`
  width: ${(props) => props.width || "100%"};
  justify-content: ${(props) => props.justifyContent || "flex-start"};
  height: 45px;
  outline: none;
  color: ${(props) =>
    props.disabled === true && props.notTypable !== true ? "#e0e0e0" : "#777"};
  font-family: Fa_IRANSans;
  font-size: 16px;
  font-weight: 600;
  border: none;
  box-shadow: none;
  padding: ${(props) =>
    props.disabled || props.outLine
      ? "5px"
      : props.className
      ? props.className.padding
      : "5px"};
  border-bottom: ${(props) => !props.outLine && "1px solid #e0e0e0"};
  border: ${(props) => props.outLine && "1px solid hsl(0, 0%, 80%)"};
  border-radius: ${(props) =>
    (props.disabled && !props.outLine) || props.outLine ? "5px" : "0px"};
  direction: rtl;
  background-color: transparent;
  margin: 2px 0px 2px 0px;
  position: relative;
  direction: ${(props) =>
    props.lang === "fa" || props.lang === "ar" ? "rtl" : "ltr"};
  &::placeholder {
    color: #e0e0e0;
    font-size: 14px;
  }
  &:focus {
    border-bottom: ${(props) => !props.outLine && "1px solid #35C974"};
    border: ${(props) => props.outLine && "1px solid #35C974"};
    transition: border-width 700ms linear;
    outline: none;
  }
`;
export const InputIcon = styled.div`
display : flex;
background-image : ${(props) => `url(${props.icon})`};
width : 10px;
height : 5px;
/* margin : ${(props) =>
  props.lang === "fa" || props.lang === "ar"
    ? "0px 0px 0px 5px"
    : "0px 5px 0px 0px"}; */
background-size : 100%;
background-repeat: no-repeat;
/* position : absolute; */
direction : ${(props) =>
  props.lang === "fa" || props.lang === "ar" ? "rtl" : "ltr"};
/* left : ${(props) =>
  props.lang === "fa" || props.lang === "ar" ? "0px" : "unset"};
right : ${(props) =>
  props.lang !== "fa" || props.lang !== "ar" ? "0px" : "unset"};
bottom : 20px; */
transform : ${(props) => props.clicked === true && "rotate(180deg)"};
transition : all ease 150ms;
cursor: pointer;

`;
export const DropdownWrapper = styled.div`
  width : 100%;
  position: relative !important;
  height: auto;
  /* flex-direction: column; */
  /* font-family: 'Arial';  */
  /* direction : ${(props) =>
    props.lang === "fa" || props.lang === "ar" ? "rtl" : "ltr"}; */
`;
export const DropdownContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: absolute !important;
  padding: 10px 0px 10px 0px;
  width: 280px;
  min-height: 50px;
  height: auto;
  max-height: 200px !important;
  border-radius: 5px;
  overflow: scroll !important;
  background-color: white;
  box-shadow: 0px 0px 20px 0px #cdcdcd7a;
  z-index: 100;
  &::-webkit-scrollbar {
    display: none;
  }
  &:focus {
    display: flex;
  }
`;
const InputIconContainer = styled(Col)`
  height: 100%;
  width: auto;
  cursor: pointer;
  position: absolute;
  padding: ${(props) =>
    props.lang === "fa" || props.lang === "ar"
      ? "0px 0px 0px 5px"
      : "0px 5px 0px 0px"};
  direction: ${(props) =>
    props.lang === "fa" || props.lang === "ar" ? "rtl" : "ltr"};
  left: ${(props) =>
    props.lang === "fa" || props.lang === "ar" ? "0px" : "unset"};
  right: ${(props) =>
    props.lang !== "fa" || props.lang !== "ar" ? "0px" : "unset"};
  bottom: 0px;
`;
export const DropList = (props) => {
  const {
    onClick,
    icon,
    show,
    lable,
    id,
    name,
    onChange,
    disabled,
    onClose,
    contentStyle,
    lang,
    justifyContent,
    letterSpace,
    outLine,
    type,
    notTypable,
    clicked,
  } = props;
  const Ref = useRef();
  const close = (e) => {
    OutSideClick(e, Ref, onClose);
  };
  useEffect(() => {
    window.addEventListener("mousedown", close, false);
    return () => {
      window.removeEventListener("mousedown", close, false);
    };
  }, []);
  return (
    <DropdownWrapper {...props} onClick={onClick} ref={Ref} lang={lang}>
      <Input
        lable={lable}
        justifyContent={justifyContent}
        letterSpace={letterSpace}
        disabled={disabled}
        notTypable={notTypable}
        id={id}
        type={type}
        outLine={outLine}
        name={name}
        lang={lang}
        onChange={onChange}
        style={{
          margin: "0px",
        }}
      />
      <InputIconContainer lang={lang}>
        <InputIcon clicked={clicked} icon={icon} lang={lang} />
      </InputIconContainer>
      {/* <Col
        xl={24} lg={24} md={24} sm={24} md={24}
        style={errorStyle}
      >{error}</Col> */}
      {show === true && (
        <DropdownContent {...props} style={contentStyle}>
          {props.children}
        </DropdownContent>
      )}
    </DropdownWrapper>
  );
};
// export const StyledSelect = () => {

// }
export const Input = (props) => {
  return (
    <StyledInput
      {...props}
      readonly={props.removeReadOnly === true && ""}
    ></StyledInput>
  );
};
